import { ChevronLeft, ChevronRight } from 'lucide-react';
import { classNames } from '../../utils/classNames';

function Pagination({ page, totalPages, onPageChange }) {
  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);
  return (
    <nav className="flex items-center justify-between gap-4" aria-label="Paginación">
      <p className="text-sm text-content-muted">
        Página <span className="font-semibold text-content-primary">{page}</span> de {totalPages}
      </p>
      <div className="flex items-center gap-1">
        <button type="button" onClick={() => onPageChange(page - 1)} disabled={page === 1} className="grid size-9 place-items-center rounded-control border bg-white text-content-secondary transition hover:bg-slate-50 disabled:opacity-40" aria-label="Página anterior">
          <ChevronLeft className="size-4" />
        </button>
        {pages.map((item) => (
          <button
            type="button"
            key={item}
            onClick={() => onPageChange(item)}
            className={classNames('grid size-9 place-items-center rounded-control text-sm font-medium transition', item === page ? 'bg-primary-600 text-white' : 'text-content-secondary hover:bg-slate-100')}
            aria-current={item === page ? 'page' : undefined}
          >
            {item}
          </button>
        ))}
        <button type="button" onClick={() => onPageChange(page + 1)} disabled={page === totalPages} className="grid size-9 place-items-center rounded-control border bg-white text-content-secondary transition hover:bg-slate-50 disabled:opacity-40" aria-label="Página siguiente">
          <ChevronRight className="size-4" />
        </button>
      </div>
    </nav>
  );
}

export default Pagination;
